import React from 'react'
import { FlatList, StyleSheet } from 'react-native'

import { Stack } from '@zet/design-system'
import { i18n } from '@zet/localization'
import { CategoryHeader, ProductsIncludedProps } from '@zet/zet-prime'
import { Image } from 'expo-image'

export default function ProductsIncluded({ products }: ProductsIncludedProps) {
  const renderItem = ({ item }: { item: { image: string } }) => {
    return (
      <Image
        source={{ uri: item.image }}
        style={styles.image}
        contentFit="contain"
      />
    )
  }
  return (
    <Stack className="px-4 py-3">
      <CategoryHeader title={i18n.t('zetPrime.productsIncluded')} />
      <FlatList
        data={products}
        renderItem={renderItem}
        contentContainerStyle={styles.list}
        scrollEnabled={false}
        ItemSeparatorComponent={() => <Stack className="h-2" />}
      />
    </Stack>
  )
}

const styles = StyleSheet.create({
  image: {
    height: 135,
  },
  list: {
    marginTop: 12,
  },
})
